export default __webpack_public_path__ + "static/media/close-blue.69166380.svg";